import styled from 'styled-components';

export const RegionalRiskSwitchContainer = styled.div`
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(5px);
  border-radius: 8px;

  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 11px;

  padding: 6px 4px;

  height: 56px;
  width: 32px;

  position: absolute;
  bottom: 100px;
  right: 12px;
`;
